import { Badge, Stack, Text } from "@mantine/core"
import { MarkdownContent } from "atlas_forecasting_app/components/common/markdown_content"
import { PageHeader, SectionCard } from "atlas_forecasting_app/components/common/page_elements"
import {
  PRIVACY_POLICY_LAST_UPDATED,
  PRIVACY_POLICY_MARKDOWN,
  PRIVACY_POLICY_TITLE,
} from "atlas_forecasting_app/content/privacy_policy_content"

export function PrivacyPolicyPage() {
  return (
    <Stack gap="lg">
      <PageHeader
        eyebrow="Public legal"
        variant="editorial"
        title={PRIVACY_POLICY_TITLE}
        subtitle="How Atlas Forecasting collects, uses, shares, and protects data."
        action={<Badge variant="light">Public</Badge>}
      />

      <SectionCard
        variant="legal"
        title="Privacy policy"
        subtitle={
          <Text c="dimmed" size="sm">
            Last updated {PRIVACY_POLICY_LAST_UPDATED}
          </Text>
        }
      >
        <MarkdownContent source={PRIVACY_POLICY_MARKDOWN} className="af-legal-markdown" />
      </SectionCard>
    </Stack>
  )
}
